"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var MenuItem_1 = require("@material-ui/core/MenuItem");
var TextField_1 = require("@material-ui/core/TextField");
var tubular_common_1 = require("tubular-common");
var dropdown = {
    marginLeft: '10%',
    width: '80%',
};
var getValue = function (op) { return (!op || op === '' ? 'None' : op); };
exports.OperatorsDropdown = function (_a) {
    var activeColumn = _a.activeColumn, handleFilterChange = _a.handleFilterChange;
    var onChange = function (_a) {
        var target = _a.target;
        return handleFilterChange({ Operator: target.value });
    };
    return (React.createElement(TextField_1.default, { style: dropdown, select: true, value: getValue(activeColumn.Filter.Operator), onChange: onChange, label: "Operator" }, tubular_common_1.ColumnModel.getOperators(activeColumn).map(function (row) { return (React.createElement(MenuItem_1.default, { key: row.Value, value: row.Value }, row.Title)); })));
};
